export const SPACE_UNIT = 8;

const spacingBase = (num: number): string => `${SPACE_UNIT * num}px`;
export const space = (...args: number[]): string => args.map(spacingBase).join(' ');
